import { Breadcrumb } from '@components/breadcrumb';

import { Header } from 'components/headers';
import { useStore } from 'models/Provider';

import { UserApps } from './user-apps';

export const Api = () => {
  const { t } = useStore();
  return (
    <>
      <Header
        // @ts-ignore
        mobileTitle={t('navigation.profile.api')}
        breadcrumbs={<Breadcrumb items={[{ label: t('navigation.profile.api') }]} />}
      />
      <UserApps />
    </>
  );
};
